import React from 'react';
import PropTypes from 'prop-types';

import CoursesSection from './CoursesSection';
import CourseCard from '../ProgramsCard/CourseCard';

const CoursesBlock = ({ title, courses, initiallyOpen }) => (
  <CoursesSection title={title} initiallyOpen={initiallyOpen}>
    {courses.map((course) => (
      <CourseCard key={course.program_id} course={course} />
    ))}
  </CoursesSection>
);

CoursesBlock.propTypes = {
  courses: PropTypes.array.isRequired,
  title: PropTypes.string.isRequired,
  initiallyOpen: PropTypes.bool,
};

CoursesBlock.defaultProps = {
  initiallyOpen: true,
};

export default CoursesBlock;
